import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LoaderIcon } from "react-hot-toast";
import { useMutation } from "react-query";
import { exams } from "../../../../../../api/exams";

const CompletedAssessmentModal = () => {
  const delayMessages = [
    "🧮 We're grading your answers and compiling your performance report, hang tight!",
    "⏳ Calculating your final score, accuracy takes a moment.",
    "🎯 Assessing your responses, your results will be ready shortly!",
  ];

  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(30);
  const [isDelaying, setIsDelaying] = useState(false);
  const [delaySeconds, setDelaySeconds] = useState(15);
  const [messageIndex, setMessageIndex] = useState(0);

  const user = JSON.parse(sessionStorage.getItem("user"));
  const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
  const assessment_id = window.sessionStorage.getItem("active-assessment-id");

  const { mutate } = useMutation(exams.getExamResults, {
    onSuccess: (data) => {
      if (data?.length || data?.results) {
        sessionStorage.setItem('activeExam', exam?.exam_name)
        navigate(`/candidate/results/${assessment_id}?userExamId=${exam?.user_exam_id}`);
      } else {
        setIsDelaying(true);
      }
    },
  });

  useEffect(() => {
    if (isDelaying) return;  
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds((prev) => prev - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      mutate({
        userId: user?.user?.user_id || sessionStorage.getItem("user_id"),
        assessmentId: assessment_id,
        userExamId: exam?.user_exam_id,
      });
    }
  }, [seconds, isDelaying]);

  useEffect(() => {
    if (!isDelaying) return;

    // Message rotation every 3 seconds
    const msgInterval = setInterval(() => {
      setMessageIndex((prev) => (prev + 1) % delayMessages.length);
    }, 3000);

    // Countdown timer
    const delayTimer = setInterval(() => {
      setDelaySeconds((prev) => {
        if (prev <= 1) {
          navigate(`/candidate/results/${assessment_id}?userExamId=${exam?.user_exam_id}`);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => {
      clearInterval(msgInterval);
      clearInterval(delayTimer);
    };
  }, [isDelaying]);

  return (
    <div
      className="h-[100vh] w-[100vw] bg-[#eee] fixed top-0 left-0 grid place-items-center p-3 md:p-16"
      style={{ zIndex: 9000000 }}
    >
      <div className="bg-white flex flex-col justify-center items-center w-[280px] h-[260px] rounded-lg shadow-md text-center">
        <LoaderIcon style={{ fontSize: 60 }} className="text-5xl w-16 h-16 mb-3" />
        {!isDelaying ? (
          <>
            <p className="text-2xl font-medium text-gray-700">
              Processing Result
            </p>
            <p className="text-lg text-gray-500 mt-3">
              Redirecting in <span className="font-semibold">{seconds}</span> seconds...
            </p>
          </>
        ) : (
          <>
            <p className="text-gray-700 text-lg px-2 font-medium mb-2">
              {delayMessages[messageIndex]}
            </p>
            <p className="text-lg px-2 text-gray-500">
              Almost there…
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default CompletedAssessmentModal;


// import React, { useState, useEffect } from "react";
// import { AssessementContext } from "../../../AssessmentContext";
// import { useNavigate, Link } from "react-router-dom";
// import { defaultState } from "../../../components/defaultState";
// import { api } from "./../../../../../../api/index";
// import ReactStars from "react-rating-stars-component";
// import { useMutation, useQuery } from "react-query";
// import { LoaderIcon, toast } from "react-hot-toast";
// import { useCustomToast } from "../../../../../../components/customtoast/CustomToastProvider";
// import { useTranslation } from 'react-i18next';
// import { useSelector } from "react-redux";
// import { exams } from "../../../../../../api/exams";

// const CompletedAssessmentModal = () => {

//   const delayMesseges = [
//       "🧮 “We’re grading your answers and compiling your performance report — hang tight!”",
//       "⏳ “Calculating your final score… accuracy takes a moment.”",
//      "🎯 “Assessing your responses — your results will be ready shortly!”"
//   ]

//   const navigate = useNavigate();
//   const [seconds, setSeconds] = useState(30);
//   const user = JSON.parse(sessionStorage.getItem('user'))
//   const exam = JSON.parse(sessionStorage.getItem("active-assessment"));
//   const {mutate} = useMutation(exams.getExamResults, {
//     onSuccess: data => {   
//       // Redirect after countdown ends
//        console.log(data); 
//        if(data?.length){
//          navigate(`/candidate/results/${assessment_id}?userExamId=${exam?.user_exam_id}`);
//        }else {
//           // set a 15 secs timer to show delay messages before redirect to result page
//        }
//     }
//   })

//   useEffect(() => {
//     // Countdown timer
//     if (seconds > 0) {
//       const timer = setTimeout(() => setSeconds((prev) => prev - 1), 1000);
//       return () => clearTimeout(timer);
//     } else {
//       mutate({
//           userId:  user?.user?.user_id  || sessionStorage.getItem('user_id'),
//           examId:  assessment_id,
//           userExamId: exam?.user_exam_id
//       });
//     }
//   }, [seconds, navigate]);

//   // const { assessment, setAssessment } = React.useContext(AssessementContext);
//   // const navigate = useNavigate();
//   // const [seconds, setSeconds] = useState(10);
//   // const [autoMove, setAutoMove] = useState(false)
//   // const [feedback, setFeedback] = useState([]);
//   // const [errorMessage, setErrorMessage] = useState('')
//   // const { t } = useTranslation();
//   // const currentLanguage = useSelector((state) => state.traslation.language);

//   // const { data: feedbackQuestion, refetch, isLoading } = useQuery(
//   //   "get feedback questions",
//   //    () => api.getFeedbackQuestions({ language: currentLanguage }),
//   //   {
//   //     onSuccess: data => {
//   //       const initialFeedback = data?.data?.map(question => ({
//   //         id: question.id,
//   //         response: null,  
//   //         text: question?.text
//   //       }));
//   //         setFeedback(initialFeedback);
//   //     }
//   //   }
//   // );

   
//   // const closeModal = (navigation) => {
//   //   setAssessment(defaultState);
//   //   if (navigation === "history") navigate("/candidate/exam-history");
//   //   else navigate("/candidate/assessments/view-assessments");
//   //   const isTestEnvironment = window.Cypress 
//   //   if (isTestEnvironment) {
//   //     return;
//   //   }
//   //   document.exitFullscreen();
//   // };


//   // const customToast = useCustomToast();
//   // const [rating, setRating] = useState(0);
//   // const [text, setText] = useState("");
//   // const [answers, setAnswers] = useState({
//   //   q1: null,
//   //   q2: null,
//   //   q3: null,
//   //   q4: null,
//   //   q5: null,
//   // });

//   // const handleRadioChange = (questionId, response) => {
//   //   setFeedback(prevFeedback => (
//   //     prevFeedback.map(item => (
//   //       item.id === questionId ? { ...item, response } : item
//   //     ))
//   //   ));
//   // };

//   // const ratingLabel = (rating) => {
//   //   if (rating == 0.5 || rating == 1) {
//   //     return t('rating-bad');
//   //   } else if (rating == 1.5 || rating == 2) {
//   //     return t('rating-fair');
//   //   } else if (rating == 2.5 || rating == 3) {
//   //     return t('rating-good');
//   //   } else if (rating == 3.5 || rating == 4) {
//   //     return t('rating-very-good');
//   //   } else {
//   //     return t('rating-excellent');
//   //   }
//   // };

//   // const ratingChanged = (newRating) => {
//   //   setRating(newRating);
    
//   //   let label = "";
//   //   if (newRating == 0.5 || newRating == 1) {
//   //     label = "Bad";
//   //   } else if (newRating == 1.5 || newRating == 2) {
//   //     label = "Fair";
//   //   } else if (newRating == 2.5 || newRating == 3) {
//   //     label = "Good";
//   //   } else if (newRating == 3.5 || newRating == 4) {
//   //     label = "Very Good";
//   //   } else {
//   //     label = "Excellent";
//   //   }
//   // };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   let content = {
//   //     comment: text,
//   //     rating: rating,
//   //   };
//   //   const feedbackSubmitted = feedback.filter( feedback => {
//   //      return feedback?.response !== null
//   //   } )
//   //   if(feedbackSubmitted?.length){          
//   //        setErrorMessage('')
//   //        const feedbackQuestions = feedbackSubmitted.filter( question => question.response !== null )
//   //        try {
//   //         toast.loading(t('sending-feedback'));          
//   //         const res = await api.sendFeedback({ 
//   //               ...content, 
//   //               questions: feedbackQuestions.map( question => {
//   //                 return { id: question?.id, response: question?.response }
//   //               })
//   //          });
//   //         toast.remove();
//   //         customToast.success(res.message);
//   //         if(sessionStorage.getItem('loginType') !== 'join'){
//   //             navigate("/candidate/exam-history");
//   //         } else navigate(`/candidate/join-exam/assessments?from=assessment`)
//   //       } catch (error) {
//   //         customToast.error(error.response.data.error);
//   //         toast.remove()
//   //       }
//   //   }
//   //   else setErrorMessage(t('no-feedback'))     
//   // };

//   // const brandedClient = JSON.parse(sessionStorage.getItem("client") || '{}');

//   return (
//     <div
//       className="h-[100vh] w-[100vw] bg-[#eee] fixed top-0 left-0 grid place-items-center p-3 md:p-16"
//       style={{ zIndex: 9000000 }}
//     >  
//        <div className="bg-white flex flex-col justify-center items-center w-[250px] h-[250px] rounded-lg shadow-md">
//         <LoaderIcon className="text-3xl mb-3" />
//         <p className="text-center text-lg font-medium text-gray-700">
//           Processing Result
//         </p>
//         <p className="text-center text-sm text-gray-500 mt-3">
//           Redirecting in <span className="font-semibold">{seconds}</span> seconds...
//         </p>
//       </div>
//       {/* <div className="w-full h-full md:w-[60%] flex items-center justify-center ">
//         <div className={`${ !autoMove ? 'h-[100vh] w-full': 'h-[350px] md:h-[500px] w-full md:w-[40vw] '}  bg-white h-auto rounded-lg p-8`}>
//          <div className="flex justify-end items-end">
//          </div>  
//           <div className="flex justify-center">
//             <div className="flex flex-col mb-10">
//               <div className="flex justify-between items-center">
//                 <div> 
//                   { <img 
//                     src="/images/checklist-with-box-and-green-label-check-mark-for-assignment-or-exam-results-vector.jpg" 
//                      alt="sucessful exam image"
//                      className="block w-[250px] h-[250px] mt-0 mx-auto mb-2" 
//                   />}
//                   <h3 className="text-primary font-semibold text-2xl mb-0 text-center">
//                     {t('assessment-completed')}
//                   </h3>
//                   {autoMove && <div className="flex justify-between mt-5 bg-green-100 border border-green-100 py-5 text-green-500 px-3 mb-3 text-lg">
//                     <p className="text-lg">
//                      {t('redirect-message', { seconds })}
//                     </p>
//                      </div>}
//                 </div>
//               </div>
//             </div>
//           </div>
//           {
//             sessionStorage.getItem('from') === 'ssh' ? 
//                <div className="flex max-[500px]:flex-col flex-wrap items-center md:flex-nowrap md:px-5 justify-center md:justify-end border border-t-2 border-gray-200 mt-5 px-3 py-3">
//                 {
//                 <button
//                    type="button"
//                   onClick={() => closeModal("history")}
//                   className="mt-3 md:mt-0 bg-green-500 py-3 px-16 rounded-lg text-white text-md"
//                 >
//                   {t('view-exams-history')}
//                 </button>
//                 }
//                 </div>
//             : null
//           }
//           { (!autoMove && sessionStorage.getItem('from') !== 'ssh') && <>
//           <p className="font-semibold text-center text-base text-darkBlue mb-9">
//               {t('completion-message')}
//             </p>
//             <p className="font-semibold text-center text-base capitalize mb-6">
//               {t('feedback-request')}
//             </p>
//             <p className="text-primary text-2xl font-bold text-center">
//               {t('rate-experience')}
//             </p>
//           <form onSubmit={handleSubmit}>
//             <div className="flex justify-center mb-0">
//               <div className="">
//                 <ReactStars
//                   count={5}
//                   onChange={ratingChanged}
//                   size={44}
//                   isHalf={true}
//                   emptyIcon={<i className="far fa-star"></i>}
//                   halfIcon={<i className="fa fa-star-half-alt"></i>}
//                   fullIcon={<i className="fa fa-star"></i>}
//                   activeColor="#ffd700"
//                 />
//                 <div className="text-center mt-2 text-gray-600">
//                   {rating > 0 && `${ratingLabel(rating)}`}
//                 </div>
//               </div>
//             </div>
//             <div className="">
//               <h3 className="mb-6 text-center text-xl font-bold ">
//                 {t('tell-more')}
//               </h3>
//               <div className="flex flex-col">
//                  {
//                     (!isLoading && feedback.length ) ?
//                     feedback.map(question => (
//                       <div key={question.id}>
//                         <p className="text-lg text-center my-3">{question.text}</p>
//                          <div className="flex mx-auto w-[90px] justify-between flex-nowrap items-center"> 
//                           <label className="flex flex-nowrap w-full items-center justify-center">
//                             <input
//                               type="radio"
//                               name={`question_${question.id}`}
//                               value="true"
//                               checked={feedback.find(item => item.id === question.id)?.response === true}
//                               onChange={() => handleRadioChange(question.id, true)}
//                               className={`relative mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
//                             />
//                             {t('yes')}
//                           </label>
//                           <label className="flex justify-center items-center">
//                             <input
//                               type="radio"
//                               name={`question_${question.id}`}
//                               value="false"
//                               checked={feedback.find(item => item.id === question.id)?.response === false}
//                               onChange={() => handleRadioChange(question.id, false)}
//                               className={`ml-8 relative mr-1 mt-0.5 h-5 w-5 appearance-none rounded-full border-2 border-solid border-primary before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-primary checked:after:bg-primary checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-primary checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] dark:border-neutral-600 dark:checked:border-primary dark:checked:after:border-primary dark:checked:after:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:border-primary dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]`}
//                             />
//                             {t('no')}
//                           </label>
//                          </div>
//                       </div>
//                     ))
//                     :
//                     <p className="text-center mt-12 text-lg">{t('loading')}</p>
//                  }               
//                 </div>
//                 <p className="text-red-500 text-xl">
//                     {errorMessage}
//                 </p>
//             </div>
//             <div className="mt-3">
//               <hr />
//               <h3 className="text-base font-medium mb-6 mt-3">
//                 {t('improvement-question')}
//               </h3>
//               <div className="flex gap-x-56 items-end">
//                 <textarea
//                   className="w-full  h-32 p-2 bg-[#F2F3F7] border border-lightGrey rounded-lg focus:outline-none focus:ring-2 focus:ring-lightGrey focus:border-transparent"
//                   placeholder={t('comment-placeholder')}
//                   value={text}
//                   onChange={(e) => setText(e.target.value)}
//                 ></textarea>
//                </div>
//               </div>
//               <div className="flex max-[500px]:flex-col flex-wrap items-center md:flex-nowrap md:px-5 justify-center md:justify-end border border-t-2 border-gray-200 mt-5 px-3 py-3">
//                 {
//                   sessionStorage.getItem('loginType') !== 'join' ?
//                 <button
//                    type="button"
//                    data-test-id="view-upcoming-exams-link"
//                   onClick={() => closeModal("history")}
//                   className="mt-3 md:mt-0 bg-green-500 py-3 px-16 rounded-lg text-white text-md"
//                 >
//                   {t('view-exams-history')}
//                 </button>
//                 :
//                 <button
//                    type="button"
//                   onClick={() => navigate(`/candidate/join-exam/assessments?from=assessment`)}
//                   className="mt-3 md:mt-0 bg-green-500 py-3 px-16 rounded-lg text-white text-md"
//                 >
//                   {'View Exams'}
//                 </button>
//               }
//                 { sessionStorage.getItem('loginType') !== 'join' &&
//                   <Link
//                     to=""
//                      className="mt-3 md:mt-0 bg-slate-200 mx-3 py-3 px-16 rounded-lg text-black text-md"
//                     onClick={() => closeModal("")}
//                   >
//                     {t('view-upcoming-exams')}
//                   </Link>}
//                 <button
//                   type="submit"
//                   style={{ backgroundColor: brandedClient?.primary_colour || undefined}} 
//                   className="bg-darkBlue max-[500px]:mt-3 ml-3 px-8 py-3 font-bold text-md text-white rounded-lg"
//                 >
//                   {t('submit-feedback')}
//                 </button>
//            </div>
//             </form>
//           </>} 
//         </div>
//         </div> */}
//     </div>
//   );
// };

// export default CompletedAssessmentModal;
